export const LoadingDots = () => {
  return (
    <div className="flex items-center justify-center space-x-1 animate-bounce">
      <div className="w-1 h-1 bg-cool-gray-100 rounded-full"></div>
      <div className="w-1 h-1 bg-cool-gray-100 rounded-full"></div>
      <div className="w-1 h-1 bg-cool-gray-100 rounded-full"></div>
    </div>
  )
}
